<template>
  <div class="view">
    <decorate></decorate>
    <div class="main info_page">
      <div class="nav">
        <div class="left">
          <router-link
            class="front icon_back"
            :to="{ path: '/', query: queryData }"
          ></router-link>
        </div>
        个人信息
        <div class="record" @click="showRule = true">隐私条款</div>
      </div>
      <div class="tab">
        <p class="p">收货地址</p>
        <!-- <p class="p" :class="{active:tabIndex==2}" @click="tabIndex=2">提现信息</p> -->
      </div>
      <Scrapper class="list" ref="view">
        <div>
          <div
            class="add_item"
            v-if="Object.keys(InfoaddressList).length > 0"
            v-for="(item, index) in homePage.addressList"
            :key="index"
            @click="qwe(item)"
          >
            <div class="front icon_locat"></div>
            <div class="right">
              <p class="big">
                {{ item.name }} <span class="span">{{ item.phone }}</span>
              </p>
              <p class="small">
                收货地址：{{ item.province + item.city + item.address }}
              </p>
              <div class="actions">
                <div class="set_default select" v-if="item.is_default == 1">
                  <span>默认地址</span>
                </div>
                <div
                  v-else
                  class="set_default"
                  @click.stop.prevent="confirmAddress(item)"
                >
                  <span>设为默认地址</span>
                </div>
                <p class="right" @click.stop.prevent>
                  <router-link
                    :to="{
                      path: '/editaddress',
                      query: {
                        userId: queryData.userId,
                        appId: queryData.appId,
                        addresssId: item.id,
                        uid: queryData.uid,
                        TopHeight: queryData.TopHeight,
                      },
                    }"
                    >编辑
                  </router-link>
                </p>
                <p class="p" @click.stop.prevent="removeAddress(item)">删除</p>
              </div>
            </div>
          </div>
          <div class="img_alt" v-if="Object.keys(InfoaddressList).length <= 0">
            <img src="../assets/images/no_adds.png" alt="" />
            <p>没有收货信息</p>
          </div>
        </div>
        <!-- <div v-show="tabIndex==2">
                <div class="bank_item"  v-if="Object.keys(InfobankList).length > 0"  v-for='(item , index) in homePage.bankList' :key="index" >
                    <p class="p">收款人姓名：{{item.name}}</p>
                    <p class="p">电话号码：{{item.phone}}</p>
                    <p class="p">银行卡号码：{{item.number}}</p>
                    <p class="p">银行名称：{{item.bank_name}}</p>
                    <p class="p">开户地址：{{item.bank}}</p>
                    <div class="actions">
                        <div @click="confirmBank(item)">
                        <div class="set_default select" v-if="item.is_default == 1">
                                <span>默认银行卡</span>
                            </div>
                            <div v-if="item.is_default == 0"  class="set_default">
                                <span >设为默认</span>
                       </div>
                       </div>
                        <p class="right">
                            <router-link :to="{path:'/editBank',query: {
                                userId : queryData.userId ,
                                appId : queryData.appId ,
                                bankId: item.id ,
                                uid : queryData.uid ,
                                TopHeight : queryData.TopHeight 
                            }}">编辑
                            </router-link>
                        </p>
                        <p class="p" @click="removeBank(item)">删除</p>
                    </div>
                </div>
                <div class="bank_item"  v-if="Object.keys(InfoAlipayList).length > 0"  v-for='(item , index) in homePage.AlipayList' :key="index" >
                    <p class="p">支付宝姓名：{{item.alipay_name}}</p>
                    <p class="p">支付宝账号：{{item.number}}</p>
                    <div class="actions">
                        <div @click="confirmAli(item)">
                        <div class="set_default select" v-if="item.is_default == 1">
                                <span>默认支付宝</span>
                         </div>
                            <div v-if="item.is_default == 0" class="set_default" >
                                <span >设为默认</span>
                       </div>
                       </div>
                        <p class="right">
                            <router-link :to="{path:'/editalipay',query: {
                                userId : queryData.userId ,
                                appId : queryData.appId ,
                                uid : queryData.uid ,
                                TopHeight : queryData.TopHeight ,
                                alipayId: item.id ,
                            }}">编辑
                            </router-link>
                        </p>
                        <p class="p" @click="removeAlipay(item)">删除</p>
                    </div>
                </div>
                
                <div class="img_alt" v-if="Object.keys(InfobankList).length <= 0 && Object.keys(InfoAlipayList).length <= 0">
                    <img src="../assets/images/noBbank.png" alt="">
                    <p>没有提现信息</p>
                </div>

            </div> -->
      </Scrapper>

      <div class="van-overlay" v-show="showRule">
        <div
          class="layer_rule"
          v-for="(item, index) in homePage.allocation.terms"
        >
          <p class="name">{{ item.title }}</p>
          <Scrapper class="scroll">
            {{ item.value }}
          </Scrapper>
        </div>
        <div class="front icon_close" @click="showRule = false"></div>
      </div>

      <div class="add_info" @click="add1()">添加新地址</div>
      <!-- <router-link v-show="tabIndex==2" class="add_info" :to="{path:'/bank', query : queryData }">
            添加新的提现方式
        </router-link> -->
    </div>
  </div>
</template>
<script>
//import { mapState } from 'vuex'
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import Scrapper from "./element/Scrapper";
import decorate from "./element/decorate";
import "../css/aside.scss";
export default {
  components: { Scrapper, decorate },
  data: function () {
    return {
      showRule: false,
      //tabIndex:1 ,
      InfobankList: {},
      InfoaddressList: {},
      InfoAlipayList: {},
      topHeight: 0,
      stats: 0,
      bcount: 1,
    };
  },
  computed: {
    ...mapState(["homePage"]),
    ...mapState("homePage", ["Syssetting"]),
  },
  watch: {
    //'$route': 'setNewsList'
  },
  created() {
    //   console.log(this.$route.params.acount)
    // console.log(this.$route.params.status)
    this.stats = this.$route.params.status;
    console.log(this.stats )
    this.bcount = this.$route.params.acount;
    console.log(this.bcount)
    // console.log(this.Syssetting)
    this.queryData = this.$route.query || {};
    this.topHeight = this.queryData.TopHeight;
    let obj = {
      userId: this.queryData.userId,
      appId: this.queryData.appId,
      uid: this.queryData.uid,
    };
    this.$store.dispatch("homePage/fetchAddressList", obj).then((res) => {
      this.InfoaddressList = res.data;
    });
    this.$store.dispatch("homePage/fetchBankList", obj).then((res) => {
      this.InfobankList = res.data;
      // console.log( this.InfobankList)
    });
    this.$store.dispatch("homePage/fetchAlipayList", obj).then((res) => {
      this.InfoAlipayList = res.data;
      // console.log( this.InfobankList)
    });
    this.$store.dispatch("homePage/fetchAllocation", obj);
  },
  methods: {
    ...mapActions(["fetchHome"]),
    ...mapMutations("homePage", ["setSyssetting"]),
    // switchTab(param){
    //     this.tabIndex = param;
    // },
    // checkDefault(param){

    // },
    add1() {
      if (this.stats == 1) {
        let obj = {
          userId: this.queryData.userId,
          appId: this.queryData.appId,
          uid: this.queryData.uid,
          goodsId: this.queryData.goodsId,
        };
        this.$router.push({
          path: "/address",
          name: "address",
          query: obj,
          params: {
            status: 1,
            acount: this.bcount,
          },
        });
      } else {
        this.$router.push({
          path: "/address",
          // name: "address",
          query: this.queryData,
        });
      }
    },
    qwe(item) {
      if (this.stats == 1) {
        this.$router.push({
          path: "/determineorder",
          name: "determineorder",
          query: this.queryData,
          params: {
            aidlist: item,
            allcount: this.bcount,
          },
        });
        // this.$router.go(-1)
      }
    },
    //删除收货地址
    removeAddress(item) {
      let obj = {
        addresssId: item.id,
        userId: this.queryData.userId,
        appId: this.queryData.appId,
        uid: this.queryData.uid,
      };
      this.$store.dispatch("homePage/fetchDeleteAddress", obj).then(() => {
        this.$dialog({
          title: "提醒",
          message: "删除收货地址成功",
        }).then(() => {});
        this.$store.dispatch("homePage/fetchAddressList", obj);
      });
    },
    //设置默认地址
    confirmAddress(item) {
      let obj = {
        addresssId: item.id,
        userId: this.queryData.userId,
        appId: this.queryData.appId,
        uid: this.queryData.uid,
      };
      this.$store.dispatch("homePage/fetchDefaultAddress", obj).then(() => {
        this.$store.dispatch("homePage/fetchAddressList", obj);
      });
    },
    //设置zfb
    confirmAli(item) {
      let obj = {
        alipayId: item.id,
        userId: this.queryData.userId,
        appId: this.queryData.appId,
        uid: this.queryData.uid,
      };
      this.$store.dispatch("homePage/fetchDefaultAlipay", obj).then(() => {
        this.$store.dispatch("homePage/fetchAlipayList", obj);
      });
    },
    //删除银行卡
    removeBank(item) {
      let obj = {
        bankId: item.id,
        userId: this.queryData.userId,
        appId: this.queryData.appId,
        uid: this.queryData.uid,
      };
      this.$store.dispatch("homePage/fetchDeleteBank", obj).then(() => {
        this.$dialog({
          title: "提醒",
          message: "删除提现信息成功",
        }).then(() => {});
        this.$store.dispatch("homePage/fetchBankList", obj);
      });
    },
    //删除zfb
    removeAlipay(item) {
      let obj = {
        alipayId: item.id,
        userId: this.queryData.userId,
      };
      this.$store.dispatch("homePage/fetchDeleteAlipay", obj).then(() => {
        this.$dialog({
          title: "提醒",
          message: "删除提现信息成功",
        }).then(() => {
          // this.$router.push({
          //     path:'/selfInfo',
          //     query: this.queryData
          // })
        });
        this.$store.dispatch("homePage/fetchAlipayList", obj);
      });
    },
    //设置默认银行卡
    confirmBank(item) {
      let obj = {
        bankId: item.id,
        userId: this.queryData.userId,
        appId: this.queryData.appId,
        uid: this.queryData.uid,
      };
      this.$store.dispatch("homePage/fetchDefaultBank", obj).then(() => {
        this.$store.dispatch("homePage/fetchBankList", obj);
      });
    },
  },
  mounted() {
    // const self=this;
    // this.$refs.view.scroll.on('scroll',(position)=>{
    //     self.$parent.scrollY=position.y;
    // })
    this.tabIndex = this.$route.params.statusTab;
    // console.log(this.tabIndex )
  },
};
</script>
